/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserMigrationQueryApplicationResponse
 */
export interface UserMigrationQueryApplicationResponse {
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryApplicationResponse
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryApplicationResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserMigrationQueryApplicationResponse
     */
    applicationUrl?: string | null;
}

/**
 * Check if a given object implements the UserMigrationQueryApplicationResponse interface.
 */
export function instanceOfUserMigrationQueryApplicationResponse(value: object): value is UserMigrationQueryApplicationResponse {
    return true;
}

export function UserMigrationQueryApplicationResponseFromJSON(json: any): UserMigrationQueryApplicationResponse {
    return UserMigrationQueryApplicationResponseFromJSONTyped(json, false);
}

export function UserMigrationQueryApplicationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserMigrationQueryApplicationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'applicationUrl': json['applicationUrl'] === undefined ? undefined : json['applicationUrl'] === null ? null : json['applicationUrl'],
    };
}

export function UserMigrationQueryApplicationResponseToJSON(json: any): UserMigrationQueryApplicationResponse {
    return UserMigrationQueryApplicationResponseToJSONTyped(json, false);
}

export function UserMigrationQueryApplicationResponseToJSONTyped(value?: UserMigrationQueryApplicationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'applicationId': value['applicationId'],
        'applicationName': value['applicationName'],
        'applicationUrl': value['applicationUrl'],
    };
}

